import { useEffect, useState } from "react";
import axios from "axios";
import "./ContactEnquiries.css";
const ContactEnquiries = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = "http://localhost/api/";

  // Fetch all enquiries
 const fetchContacts = async () => {

  try {

    setLoading(true);

    const res = await axios.get(
      "http://localhost/api/getContactEnquiries.php"
    );

    console.log(res.data);

    setContacts(res.data.data);

  } catch (err) {

    console.error(err);
    alert("Failed to fetch contact enquiries.");

  } finally {

    setLoading(false);

  }

};

  useEffect(() => {
    fetchContacts();
  }, []);

  // Delete enquiry
  const deleteContact = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this enquiry?"
    );

    if (!confirmDelete) return;

    try {
      await axios.get(`${API}/deleteContactEnquiry.php?id=${id}`);

      setContacts((prev) => prev.filter((item) => item.id !== id));

      alert("Enquiry deleted successfully.");
    } catch (error) {
      console.error(error);
      alert("Unable to delete enquiry.");
    }
  };

  return (
    <div className="contact-enquiries">

      <div className="page-header">
        <h2>Contact Enquiries</h2>
      </div>

      {loading ? (
        <h3>Loading...</h3>
      ) : contacts.length === 0 ? (
        <h3>No enquiries found.</h3>
      ) : (
        <table className="contact-table">

          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Message</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {contacts.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>

                <td>{item.name}</td>

                <td>{item.email}</td>

                <td>{item.message}</td>

                <td>
                  {new Date(item.created_at).toLocaleString()}
                </td>

                <td>
                  <button
                    className="delete-btn"
                    onClick={() => deleteContact(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      )}

    </div>
  );
};

export default ContactEnquiries;